import { FC, useEffect, useMemo, useState } from 'react';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { useBigdataFn } from '@/common/utils/bigdata';
import { getPopulationTrackingData } from '@/common/tracking/youth';
import styles from './index.module.less';
import HeatSwitch from './HeatSwitch';

/**
 * @Description 商圈详情-基本信息栏
 */
const Group: FC<{
  groupName: string,
  list: any[],
  active: {
    /** 格式为 livePopulations_code、livePopulationsWork_code、livePopulationsResiden_code */
    keyName: string,
  },
  onHeatEvent: any,
}> = ({
  groupName,
  list,
  active,
  onHeatEvent,
}) => {
  const [checked, setChecked] = useState<boolean>(false);
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook

  useEffect(() => {
    const curGroupHasSelected = !!(list?.find((item) => item.keyName === active?.keyName));
    if (active?.keyName && !curGroupHasSelected && checked) {
      // 之前选中热力图，现在热力图使用其他字段了，需要取消这个选中
      setChecked(false);
    }
  }, [active, list, checked]);

  const isHeatMap = useMemo(() => {
    return isArray(list) && list.some(itm => !!itm?.isHeatMap);
  }, [list]);

  const methods = useMethods({
    onChange: (val: boolean, item?: any) => {
      setChecked(val);
      // const item = list.length === 3 ? list[2] : null; // 约定使用第三个指标的热力图配置
      onHeatEvent?.(val, item);
      if (val && item) { // 开启了热力图
        const { keyName } = item;

        // 需要补充埋点
        const trackingData = getPopulationTrackingData(keyName);
        console.log('trackingData1', keyName, trackingData);
        bigdataFn(...Object.values(trackingData || {}));
      }
    }
  });


  return (
    <div className={styles.group}>
      <div className={styles.titleRow}>
        <div className={styles.name}>{groupName}</div>
        {/* 默认第一项500m */}
        {isHeatMap ? <HeatSwitch checked={checked} onChange={(isChecked) => methods.onChange(isChecked, list?.[0])}/> : <></>}
      </div>

      <div className={styles.listWrapper}>
        {
          list.map((itm, idx) => (
            <div
              key={idx}
              className={cs(styles.listItem, itm.keyName === active?.keyName ? styles.active : '')}
              onClick={() => methods.onChange(true, itm)}
            >
              {
                itm.keyName === active?.keyName ? <div className={styles.iconCon}>
                  <img
                    src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_checkbox_select@2x.png`}
                    width='100%'
                    height='100%'/>
                </div> : <></>
              }
              <div className={styles.valueRow}>
                <div className='fs-14 c-222 bold'>{itm?.value || '-'}</div>
                {
                  itm?.value && itm?.unit ? <div className='fs-12 c-222'>{itm?.unit}</div> : <></>
                }
              </div>
              <div className={styles.nameRow}>
                <span className={'fs-12 c-666'}>{itm?.title}</span>
                {(itm?.basicValue && itm?.tag) ? <div className={styles.tag}>{itm.tag.replace('内', '')}</div> : <></>}
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default Group;
